{
  "list": {
    "title": "Message Log",
    "searchPlaceholder": "Search by phone number",
    "filters": {
      "system": "System",
      "status": "Status",
      "fromDate": "From Date",
      "toDate": "To Date"
    },
    "columns": {
      "date": "Date",
      "system": "System",
      "template": "Template",
      "language": "Language",
      "phone": "Phone",
      "status": "Status",
      "attempts": "Attempts"
    }
  },
  "status": {
    "queued": "Queued",
    "sending": "Sending",
    "sent": "Sent",
    "delivered": "Delivered",
    "read": "Read",
    "failed": "Failed"
  },
  "language": {
    "ar": "Arabic",
    "en": "English"
  },
  "details": {
    "title": "Message Details",
    "basicInfo": "Basic Information",
    "system": "System",
    "templateKey": "Template Key",
    "templateName": "Meta Template Name",
    "language": "Language",
    "idempotencyKey": "Idempotency Key",
    "providerMessageId": "Meta Message ID",
    "headerType": "Header",
    "headerNone": "None",
    "headerImage": "Image ({{format}}, {{size}})",
    "headerImageSize": "{{value}} KB",
    "variables": "Variables",
    "variableName": "Name",
    "variableValue": "Value",
    "messageText": "Message Text",
    "noMessageText": "This template has no stored message text.",
    "statusSteps": "Status",
    "steps": {
      "created": "Created",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "failed": "Failed"
    },
    "attempts": "Attempts",
    "nextAttemptAt": "Next Attempt",
    "failureReason": "Failure Reason",
    "retry": "Resend",
    "retryConfirmTitle": "Resend this message?",
    "retryConfirmDescription": "Message \"{{template}}\" will be resent to {{phone}}.",
    "retrySuccess": "Message resent successfully",
    "notFound": "This message could not be found.",
    "failureGeneric": "The message could not be sent. Try again later.",
    "failureCodes": {
      "1": "The WhatsApp provider service is temporarily unavailable",
      "2": "The WhatsApp provider service is temporarily unavailable",
      "4": "The request limit was exceeded, try again later",
      "100": "The message data is invalid",
      "130429": "The message rate limit was exceeded, try again later",
      "131000": "An unexpected error occurred at the WhatsApp provider",
      "131026": "The message could not be delivered: the number is not on WhatsApp or does not accept messages",
      "131030": "The recipient number is not allowed to receive messages",
      "131042": "There is a payment problem with the WhatsApp Business account",
      "131047": "The conversation window has expired, a new template must be sent",
      "131048": "Sending is restricted because too many messages were rejected",
      "131049": "The message was not delivered to protect engagement quality with the recipient",
      "131053": "The message image upload failed, check the image",
      "131056": "The message limit for this recipient was exceeded, try again later",
      "132000": "The number of template variables does not match the approved template",
      "132001": "The template does not exist or is not approved in this language",
      "132005": "The translated template text is too long",
      "132012": "The template variable values are invalid",
      "190": "The WhatsApp account connection has expired and must be renewed",
      "PROVIDER_UNAVAILABLE": "WhatsApp is unavailable; request a new code",
      "RECIPIENT_NOT_ON_WHATSAPP": "The number is not on WhatsApp",
      "TEMPLATE_NOT_APPROVED": "The verification template is not approved in Meta yet",
      "PROVIDER_REJECTED": "WhatsApp refused the message; request a new code"
    },
    "codeHidden": "Code hidden",
    "codeNotResent": "A verification code message is not resent; request a new code from the system."
  }
}
